import Axios from 'axios'
import { required } from "vuelidate/lib/validators";

export const DiagnosticosServices = {
    api: {
        async getAll() {
            return Axios.get('diagnosticos')
                .then((response) => { return response.data })
                .catch((error) => { throw error })
        },
        async find(id) {
            return Axios.get('diagnosticos/' + id)
                .then((response) => { return response.data })
                .catch((error) => { throw error })
        },
        async create(nombre) {
            return Axios.post('diagnosticos', { nombre })
                .then((response) => { return response.data })
                .catch((error) => { throw error })
        },
        async put(id, nombre) {
            return Axios.put('diagnosticos/' + id, { nombre })
                .then((response) => { return response.data })
                .catch((error) => { throw error })
        },
        async delete(diagnostico) {
            return Axios.delete('diagnosticos/' + diagnostico.id)
                .then((response) => { return response.data })
                .catch((error) => { throw error })
        },
    },
    //VALIDATIONS
    validations: {
        nombre: { required },
    },
    //TABLELIST
    headers() {
        return [
            { value: '#', sortable: true },
            { value: 'Nombre', sortable: true },
        ]
    },
    body() {
        return [
            {
                class: 'w-100',
                data: [{ value: 'id', class: 'text-primary', label: '#' }],
            },
            {
                class: 'important',
                data: [{ value: 'nombre', label: 'Nombre' }],
            },
        ]
    },
    dataList: [
        { name: 'nombre', class: 'text-primary' },
    ],
}
